import './css/whycitieslove.css'

export const WhyCitiesLove = () => {
    const points = [
        "Scales from small towns to large municipalities",
        "Simple launch with no IT burden on city staff",
        "Optional sponsored ads to fund the platform sustainably"
    ];

    return (
        <div className="section-container" style={{ backgroundColor: "#ffffff" }}>
            <div className="cities-love-section">
                <div className="cities-love-title">Benefits</div>

                <div className="row why-grid">
                    <div className="col-md-6 img-col">
                        <img
                            src="/images/WhyCitiesLoveIt.png"
                            className="img-fluid cities-love-img"
                            alt="Why Cities Love It"
                        />
                    </div>

                    <div className="col-md-6 list-col">
                        <ul className="numbered-list">
                            {points.map((point, index) => (
                                <li key={index}>
                                    <span className="number-block">
                                        <span className="number-glyph">{index + 1}</span>
                                    </span>
                                    <span className="numbered-text">
                                        <span className="text-inner">{point}</span>
                                    </span>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>

            </div>
        </div>
    );
};
